export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.10-0914.20",
  commitId: "fe78970eff169c717060bffd274663166f9a7441",
  commitTime: "2026-04-10T09:14:20.000Z",
});
